import { isPlatformBrowser } from "@angular/common";
import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TranslationService {
  constructor(
    private readonly translateService: TranslateService,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) { }

  initializeTranslation() {
    if (isPlatformBrowser(this.platformId)) {
      const userLang = navigator.language || 'en';
      const languageCode = userLang.split('-')[0];
      this.translateService.setDefaultLang(languageCode);
      this.translateService.use(languageCode);
    } else {
      this.translateService.setDefaultLang('en');
    }
  }

  get(key: string): Observable<string> {
    return this.translateService.get(key);
  }

  getCurrentLang(): string {
    return this.translateService.currentLang || 'en';
  }

  getCodeLanguage(): string {
    return this.getCurrentLang().toLowerCase() + "-" + this.getCurrentLang().toUpperCase();
  }

  getDateFormat(): string {
    const lang = this.getCurrentLang();
    return lang === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
  }

  getDatePipeLang(): string {
    const lang = this.getCurrentLang();
    return lang === 'fr' ? 'fr-FR' : 'en-US';
  }

}
